var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    stroke: "#A5A5A8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2152_25265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.75 13V21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13V21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15V23",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 16.58C21.8012 16.1195 22.6621 15.3115 23.1881 14.2915C23.7141 13.2715 23.8731 12.1016 23.6386 10.9781C23.4041 9.85472 22.7902 8.84617 21.9 8.12179C21.0099 7.39742 19.8976 7.00131 18.75 6.99996H17.49C17.173 5.77248 16.5689 4.63791 15.7273 3.68976C14.8858 2.74161 13.8309 2.00703 12.6498 1.54658C11.4686 1.08612 10.1949 0.912974 8.93368 1.0414C7.67246 1.16983 6.45981 1.59615 5.3957 2.28524C4.33158 2.97433 3.44647 3.90644 2.81331 5.00475C2.18015 6.10307 1.81708 7.33613 1.75401 8.60231C1.69095 9.86849 1.92971 11.1315 2.45061 12.2873C2.9715 13.4431 3.75962 14.4585 4.75 15.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.d77d41b08de6e241fbf1cbc372faea8b.svg";
export { ForwardRef as ReactComponent };